import ExistingResourceSelect from "@imminently/decisively-ui/ExistingResourceSelect";
import { useState } from "react";

import { ComponentPage, ComponentPreview, ComponentSection } from "../components/ComponentPage";

const options = [
  { value: "mapping-1", label: "Employee import (contact, CSV)" },
  { value: "mapping-2", label: "Leave import (extensions, CSV)" },
];

export function ExistingResourceSelectPage() {
  const [selectedId, setSelectedId] = useState<string>();
  const [missingSelectedId, setMissingSelectedId] = useState<string | undefined>("removed-mapping");
  const [viewSelectedId, setViewSelectedId] = useState<string | undefined>("mapping-1");
  const [viewedId, setViewedId] = useState<string>();

  return <ComponentPage title="Existing Resource Select" description="Select or clear an existing resource. A saved selection remains visible when it is missing from the available options.">
    <ComponentSection title="Available resources">
      <ComponentPreview className="w-full justify-stretch">
        <div className="w-full max-w-md">
          <ExistingResourceSelect resourceLabel="mapping" options={options} selectedId={selectedId} onSelectionChange={setSelectedId} />
        </div>
      </ComponentPreview>
    </ComponentSection>
    <ComponentSection title="Viewing the selected resource" description="With onView, a View button at the end of the select opens the selected resource. It is hidden when nothing is selected or the selection is missing.">
      <ComponentPreview className="w-full justify-stretch">
        <div className="grid w-full max-w-md gap-2">
          <ExistingResourceSelect resourceLabel="mapping" options={options} selectedId={viewSelectedId} onSelectionChange={setViewSelectedId} onView={setViewedId} />
          <p className="text-xs text-muted-foreground">{viewedId ? `Viewed ${viewedId}` : "Nothing viewed yet"}</p>
        </div>
      </ComponentPreview>
    </ComponentSection>
    <ComponentSection title="Missing saved resource" description="The selected ID stays visible so the user can replace or clear it.">
      <ComponentPreview className="w-full justify-stretch">
        <div className="w-full max-w-md">
          <ExistingResourceSelect resourceLabel="mapping" options={options} selectedId={missingSelectedId} onSelectionChange={setMissingSelectedId} />
        </div>
      </ComponentPreview>
    </ComponentSection>
  </ComponentPage>;
}
